import { getLogger } from 'app-components/utils/core';
import { createAppSlice } from 'app-components/utils/redux-store/createAppSlice';

import { commonSelectors, createResourceEntityAdapter } from '../core/resourceSliceUtils';
import { mileageTrackerAddressApi } from '../mileage-tracker/mileageTrackerApi';
import {
  MILEAGE_TRACKER_ADDRESS_REDUCER_KEY,
  type MileageTrackerAddressRecord,
  type MileageTrackerAddressState,
} from './mileageTrackerAddressTypes';

const initialState: MileageTrackerAddressState = {
  entities: {},
  ids: [],
  isLoading: false,
  loadPending: true,
  error: null,
  lastSyncDate: null,
};
const log = getLogger('app-components/flux/mileageTrackerAddress/mileageTrackerAddressSlice.ts');

const entityAdapter = createResourceEntityAdapter<MileageTrackerAddressRecord>();
const entitySelectors = entityAdapter.getSelectors();

export const slice = createAppSlice({
  name: MILEAGE_TRACKER_ADDRESS_REDUCER_KEY,
  initialState: entityAdapter.getInitialState(initialState),
  reducers: (create) => ({
    fetch: create.asyncThunk(
      async (_: void) => {
        log.debug('Getting stored addresses');
        return await mileageTrackerAddressApi.fetch();
      },
      {
        pending(state) {
          state.isLoading = true;
        },
        fulfilled(state, action) {
          entityAdapter.setAll(state, action.payload);
          state.error = undefined;
        },
        rejected(state, action) {
          log.error('Received error', action.error);
          state.error = action.error;
        },
        settled(state) {
          state.isLoading = false;
          state.loadPending = false;
        },
      },
    ),
  }),
  selectors: {
    ...entitySelectors,
    ...commonSelectors,
  },
});

export const mileageTrackerAddressActions = slice.actions;
export const mileageTrackerAddressSelectors = slice.selectors;
export { slice as mileageTrackerAddressSlice };

/** Every stored address, by id. */
export const getAddressesById = slice.selectors.selectEntities;

export default slice.reducer;
